import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";
import { CropData, Product } from "src/app/_models/interfaces";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { LocationStateService } from "src/app/_services/location-state.service";
import { RequestsService } from "src/app/_shared/services/requests.service";
import Swal from "sweetalert2";
import { IData, Promotion } from "../agrishop/agrishop.interface";
import { AgrishopService } from "../agrishop/services/agrishop.service";
import { PromotionService } from "../agrishop/services/promotion.service";
import { map } from "rxjs/operators";
import { INotification, IOption } from "./push-notifications.interfaces";
// import { NotificationService } from 'src/app/_services/notification.service';
import { NotificationsService } from "./services/notifications.service";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

declare var $: any;
@Component({
  selector: "app-push-notifications",
  templateUrl: "./push-notifications.component.html",
  styleUrls: ["./push-notifications.component.scss"],
})
export class PushNotificationsComponent implements OnInit {
  constructor(
    private agrishopService: AgrishopService,
    private requestService: RequestsService,
    private notificationService: NotificationsService,
    private locationState: LocationStateService,
    private authenticationService: AuthenticationService,
    private promotionService: PromotionService,
    private sanitizer: DomSanitizer,
  ) {}

  @Input() notificationsData=[];
  @Input() notificationsFilter;
  @Input() loadingNotifications;
  filters = {
    supplier_id: "",
    category: "",
    search: "",
    limit: 200,
    activePage: 1,
  };
  currentProduct: Product;
  searchItem: string;
  pPage = 1;
  page =  1
  dPage  = 1;
  totalItems = 16;
  title: string = ''

  totalPages = 1
  perPage = 12
  showCtaModal: boolean = false;
  showRecepientsModal: boolean = false;
  products: Product[];
  userPhone:string=null;
  districts: Observable<IData[]> = new Observable(null);
  crops:  Array<IOption> = []
  loading = false;
  loadingData = false;
  total = 0;
  farmers: Array<string> = [];
  farmerName: string = null;
  countryName: string = null;
  fileName: string = null;
  multiple:string = null;
  notCriteria:boolean = false;
  notification = {};
  modules = [
    {
      label: "Home",
      value: "home",
    },
    {
      label: "Agrishop Page",
      value: "shop",
    },
    {
      label: "Agrishop Item",
      value: "shop_input_details",
    },
    {
      label: "Promotions",
      value: "promotions",
    },
    {
      label: "Credits",
      value: "credits",
    },
    {
      label: "Orders",
      value: "order",
    },
    {
      label:"Farm manager",
      value:"farm_manager"
    },
    {
      value: "farm_manager_crop",
      label:"Farm manager crop"
    },
    {
      value: "loan_application",
      label:"Loans application"
    },

    {
      label: "Farm Records",
      value: "farm_records",
    },
    {
      label: "Farm plan calendar",
      value: "farm_plan_calendar_engagement",
    },
    {
      label: "Fertigation",
      value: "fertigation",
    },
    {
      label: "Contact Us",
      value: "contact_us",
    },
    {
      label: "User Profile",
      value: "profile",
    },
    {
      label: "Anniversary",
      value: "anniversary",
    },
    {
      label: "Diagnosis",
      value: "diagnosis",
    },
    {
      label: "Customer Orders",
      value: "customer_orders",
    },
    {
      label: "Garden mapping",
      value: "garden_mapping",
    },
    {
      label: "Better Extension",
      value: "better_extension",
    },

  ];
  farm_plan_destinations=[
    {
      label: 'Agronomy info',
      value: 'agronomy_info'
    },
    {
      label: 'Farm plan',
      value: 'farm_plan'
    },
    {
      label: 'Crop Calendar',
      value: 'crop_calendar'
    }

  ]
  @Input() notificationForm: FormGroup = new FormGroup({
    userCriteria: new FormGroup({
      user_mode: new FormControl(null, Validators.nullValidator),
      single: new FormControl(null, Validators.nullValidator),
      username: new FormControl(null, Validators.nullValidator),
      districts: new FormControl(),
      crops: new FormControl(),
      user_id: new FormControl(null, Validators.nullValidator),
    }),
    clickAction: new FormGroup({
      page: new FormControl(null, Validators.nullValidator),
      item: new FormControl(null, Validators.nullValidator),
      destination: new FormControl(null, Validators.nullValidator),
      crop: new FormControl(null, Validators.nullValidator),
    }),
    notification: new FormGroup({
      title: new FormControl('', Validators.required),
      body: new FormControl('', Validators.required),
      image: new FormControl(null, Validators.nullValidator),
      imageUrl:  new FormControl(null, Validators.nullValidator),
    }),
  });
  promotions$: BehaviorSubject<Promotion[]> = this.promotionService.promotions$;
  selectedImageUrl: any=null;
  openPromotions$ = this.promotions$.pipe(
    map((promo) => promo.filter((v) => v.is_active))
  );

  ngOnInit(): void {
    const { country } = this.authenticationService.getCurrentUserValue();
    this.countryName = country;
    this.getNotifications(1);
    this.getDistrictData();
    this.getCrops();
    this.newForm();
  }

  newForm() {
    this.notificationForm.reset();
  }

  getFarmer(event){
    event.preventDefault();
    this.loading = true
    const params = {
      phone: Number(this.userPhone).toString()
    }
    this.requestService
      .prof_post(`api/v1/auth/check_farmer`, params)
      .subscribe(
        (res) => {
            // user_id: res['farmer_id'],
          if (res.farmer_name === 'NA') {

            Swal.fire({
              title: 'non existent',
              confirmButtonText: 'ok',
              type: 'error',
              text: `user does not exist`,
              showLoaderOnConfirm: true,
            })
          }else{
            this.notificationForm.controls.userCriteria.patchValue({ user_id: res.farmer_id });
            this.farmerName = res.farmer_name
          }
          this.loading = false
        },
        (err) => {
          Swal.fire({
            title: 'Error, failed to load user ',
            type: 'warning',
          })
          this.loading = false
        }
      )
  }

  getDistrictData() {
    this.districts = this.locationState.disticts$;
  }

  onModuleChange() {
    this.notificationForm.controls.clickAction.patchValue({ item: null });
  }
  getCrops() {
    this.loading = true;
    this.agrishopService.getCrops().subscribe(
      (res: { data: CropData[] }) => {
        this.crops = res.data.map(({name}) => ({label:name, value: name}))
        this.loading = false;
      },
      (err) => { 
        this.loading = false;
        console.log(err)
      }
    )
  }
  handleProductSelect(value: Product) {
    if (this.hasStock(value)) {
      this.notificationForm.controls.clickAction.patchValue({ item: value.id });
    } else {
      Swal.fire({
        text: "Selected product has no stock available",
        type: "warning",
      });
    }
  }
  hasStock(item: Product) {
    let status = true;
    if (item.stock !== "available") {
      status = false;
    } else if (item.packaging) {
      status = !item.packaging.every((v) => String(v.in_stock) === "false");
    } else if (item.package_stock) {
      status = !item.package_stock.every((v) => String(v) === "false");
    }
    return status;
  }

  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
    const file =  event.target.files[0];
    this.notificationForm.controls.notification.patchValue({ image: event.target.files[0], imageUrl:null});
    const reader = new FileReader();
    reader.onload = e => this.selectedImageUrl = reader.result.toString();
    this.fileName = event.target.files[0].name;
    reader.readAsDataURL(file);
    }else{
      this.notificationForm.controls.notification.patchValue({ image: null});
      this.fileName = null;
      this.selectedImageUrl = null;
    }
}

  openRecepientsModal() {
    this.showRecepientsModal = true;
    $("#recepients").modal("show");
  }

  closeRecepientsModal() {
    $("#recepients").modal("hide");
    $("#create-notification").modal("show");
    this.showRecepientsModal = false;
  }
  openCTAModal() {
    this.showCtaModal = true;
    $("#cta").modal("show");
  }

  closeCTAModal() {
    $("#cta").modal("hide");
    $("#create-notification").modal("show");
    this.showCtaModal = false;
  }

  getParams(data: any = {}) {
    // add country data
    const { country } = this.authenticationService.getCurrentUserValue();
    // add salt to refetch the data incase of any updates
    let { salt, ...rest } = data;
    salt = salt ? Math.round(Date.now() / 1000) * 1000 : null;
    const obj = {
      limit: this.filters.limit,
      page: this.filters.activePage,
      category: this.filters.category,
      supplier_id: this.filters.supplier_id,
      status: 'active',
      salt,
      country__like: country,
      ...rest,
    };
    Object.keys(obj).forEach(
      (key) => (obj[key] == null || obj[key] == "") && delete obj[key]
    );
    return obj;
  }

  async getProducts(params: any = {}) {
    this.loading = true;
    const queryParams = new URLSearchParams(this.getParams(params)).toString();
    try {
      const response = await this.agrishopService
        .getInputs(queryParams)
        .toPromise();
      this.products = response.data;
      this.loading = false;
      if (this.products.length == 0) {
        Swal.fire({
          title: `No results found for search ${params.search__like}`,
          type: "info",
        });
      }
    } catch (error) {
      this.loading = false;
      Swal.fire({ title: "Loading inputs failed", type: "error" });
    }
  }

  async getRecipientsCount(){
    if (this.notificationForm.get('userCriteria').invalid){
      Swal.fire({ title: "Select users based on criteria", type: "error" });
    }else{
      const recipientsForm = {
        ...this.notificationForm.get('userCriteria').value,
      }
      this.loading = true;
      await this.notificationService.notificationRecipients(recipientsForm).subscribe(
        (res)=>{
          this.notCriteria = true;
          this.loading = false;
          if(res.length > 0){
            this.total = res[0].total
            this.farmers = res[0].farmers?res[0].farmers:[]
            Swal.fire({
              text: `${this.total} people ${this.notification['sent'] ? 'received' : 'will  receive'} this notification`,
              type: "success",
            });
          }
        },
        (error)=>{
          this.loading=false;
          this.total = 0
          this.farmers =  []
          Swal.fire({
            text: "Error  occured",
            type: "error",
          });
          console.log('failed')
        }
      );
      this.closeRecepientsModal()
    }
  }

  async sendNotification(event){
    this.saveNotification(event, true);
  }

  async saveNotification(event, sendNow = false){
    event.preventDefault();
    if (this.notificationForm.get('userCriteria').invalid){
      Swal.fire({ title: "Select users based on criteria", type: "error" });
      return;

    }
    if (this.notificationForm.get('notification').invalid){
      Swal.fire({ title: "Notification should have a title and body atleast", type: "error" });
      return;

    }
    const {page, item} = this.notificationForm.get('userCriteria').value;
    if ((page === 'shop_input_details' || page==='promotions' ) && !item){
      Swal.fire({ title: `${page} requires you to select an item`, type: "error" });
      this.openCTAModal();
      return;
    }
    else{
      await this.dispatch(sendNow);

    }
  }

  async dispatch(sendNow){
    this.loading = true;
    const formData = this.alignFormData(sendNow)
    await this.notificationService.createNotifications(formData).subscribe(
      (res) => {
        this.loading = false;
        Swal.fire({ 
          title: `Notification ${sendNow? 'sent' : 'saved'}!`, 
          type: "success",
          timer: 2000,
        }).then(()=>{
          this.getNotifications(1)
          this.closeNotificationsModal()
          this.resetForm()
      });
      },
      (error) => {
        this.loading = false;
        this.total = 0
        Swal.fire({ 
          title: "Notification failed.", 
          type: "error",
          timer: 2000,
        });
        console.log('failed')
      }
    );
    this.closeRecepientsModal()
  }

  openNotificationsModal(){
    $('#new-notification').modal('show');
  }
  closeNotificationsModal(){
    $('#new-notification').modal('hide');
  }

  viewNotification(notification: INotification){
    this.notification = notification;
    this.openNotificationsModal();
    this.total = notification.users;
    this.notCriteria = true;
    this.selectedImageUrl = notification.image
    this.notificationForm.controls.userCriteria.patchValue({
      user_id: notification.user_id,
      user_mode: notification.user_mode,
      districts: notification.districts,
      crops: notification.crops
    });
    this.notificationForm.controls.notification.patchValue({ 
      title: notification.title,
      body: notification.body,
      imageUrl: notification.image
    });
    this.notificationForm.controls.clickAction.patchValue({ 
      page: notification.page,
      item: notification.item,
      destination: notification.destination,
      crop: notification.crop
    });
    this.getRecipientsCount();
  }

  alignFormData(sendNow = true){
    let formData = new FormData()
    for (const key in this.notificationForm.controls) {
      if (this.notificationForm.get(key) instanceof FormGroup){

          Object.keys(this.notificationForm.get(key).value).filter(innerKey  => {
            return this.notificationForm.get(key).get(innerKey).value
          }).map(innerKey => {
            formData.append(innerKey, this.notificationForm.get(key).get(innerKey).value);
          })
        }
      }
    if(sendNow){
      formData.append('sent', sendNow.toString());
    }
    if(this.notification['id']){
      formData.append('id', this.notification['id']);
    }

    return formData
  }
  resetForm(){
    this.notificationForm.reset()
    this.notCriteria = false;
    this.fileName = null;
    this.multiple=null;
    this.selectedImageUrl = null;
    this.total = 0;
    this.farmers = [];
    this.loading = false;
    this.farmerName = null;
    this.notification = {};
  }
  async getNotifications(page: number) {
    this.loadingData = true;

    await this.notificationService.getNotifications({
      page,
      title:this.title
    }).subscribe(
      (res: INotification[]) => {

        this.loadingData = false;
        this.page = page
        this.notificationsData = res;
        if (this.notificationsData.length===this.perPage){
          this.totalItems=(this.perPage*this.page)+1
        }else{
          this.totalItems=this.perPage*this.page
        }
      },
      (err) => {
        this.loadingData = false;
        console.log(err);
      }
    );
  }
}
